import { isActive } from './date';

export const filterByEndDate = funds => {
  return funds.filter(fund => !fund.endDate || isActive(fund.endDate));
};
